"use client";

import { useEffect, useState } from "react";
import { commonContext } from "./context";

export const CommonContextProvider = ({ children, ...other }) => {
    const [is480, setIs480] = useState(false);
    const [is768, setIs768] = useState(false);
    const [is992, setIs992] = useState(false);
    const [is1199, setIs1199] = useState(false);
    const [is1200, setIs1200] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const q480 = window.matchMedia("only screen and (max-width : 480px)");
        const q768 = window.matchMedia("only screen and (max-width : 769px)");
        const q992 = window.matchMedia(
            "only screen and (min-width : 769px) and (max-width : 992px)"
        );
        const q1199 = window.matchMedia(
            "only screen  and (max-width : 1199px)"
        );
        const q1200 = window.matchMedia("only screen and (max-width : 1200px)");
        const qDesktop = window.matchMedia(
            "only screen and (min-width : 1201px)"
        );

        const update = () => {
            setIs480(q480.matches);
            setIs768(q768.matches);
            setIs992(q992.matches);
            setIs1199(q1199.matches);
            setIs1200(q1200.matches);
            setIsDesktop(qDesktop.matches);
        };

        update();

        const handler = () => update();

        const add = (mq) => {
            if (mq.addEventListener) mq.addEventListener("change", handler);
            else mq.addListener(handler);
            return () => {
                if (mq.removeEventListener)
                    mq.removeEventListener("change", handler);
                else mq.removeListener(handler);
            };
        };

        const cleanups = [q480, q768, q992, q1199, q1200, qDesktop].map(add);
        return () => cleanups.forEach((fn) => fn());
    }, []);

    const contextValues = {
        ...other,
        is480,
        is768,
        is992,
        is1199,
        is1200,
        isDesktop,
    };

    return (
        <commonContext.Provider value={contextValues}>
            {children}
        </commonContext.Provider>
    );
};
